import SeoLandingPage from "@/components/SeoLandingPage";

const HoarderCleanout = () => (
  <SeoLandingPage
    slug="hoarder-cleanout-wi"
    metaTitle="Hoarder Cleanout WI | Compassionate, Discreet Hoarding Cleanup"
    metaDescription="Respectful hoarding cleanout services in Wisconsin with careful sorting, debris hauling, and clear communication for families and property owners."
    h1="Hoarder Cleanouts in Wisconsin"
    heroImage="/images/chimney_untouched.jpg"
    heroIntro="Hoarding situations are not just messes — they're months or years of pain. Our crews work slowly, respectfully, and confidentially to restore the home without judgment."
    serviceName="Hoarder Cleanout"
    bullets={[
      "Trauma-informed approach: we work at the pace the homeowner or family can handle.",
      "Heavy-duty PPE for crew and full deep-clean once the home is cleared.",
      "Biohazard handling: animal waste, decomposing food, mold, sharps.",
      "Recovery of important documents, family photos, and items of value.",
      "Coordination with social workers, APS, and family-court contacts when needed.",
      "Complete discretion — unmarked trucks available, neighbors don't need to know.",
    ]}
    whyUs={[
      "We've worked through Level 3, 4, and 5 hoarding situations across Northeast Wisconsin.",
      "No judgment, ever. We've seen everything and we lead with compassion.",
      "Confidential client list — your situation never appears in our public reviews.",
      "Insured and licensed for biohazard remediation throughout Wisconsin.",
    ]}
    processSteps={[
      { title: "Private consultation", detail: "We meet (or video-call) with the family or homeowner to understand the situation and the goals." },
      { title: "Phased plan", detail: "For complex hoardings, we work in zones over multiple days so the homeowner stays in control." },
      { title: "Clearing and recovery", detail: "Crew clears debris layer by layer, recovering important items along the way." },
      { title: "Deep clean & next steps", detail: "Once cleared, we deep-clean and connect the family with cleaning, repair, or mental-health resources as requested." },
    ]}
    faqs={[
      { q: "Will you judge the homeowner or family?", a: "Never. Hoarding is recognized as a mental-health condition, and we approach every job with the same compassion we'd want for our own family. We don't gossip, we don't post, and we don't share photos publicly." },
      { q: "Can family members be present?", a: "Yes, and often it helps. The homeowner or family member can stay involved at every step — or step away while we work. We follow your lead." },
      { q: "How long does a hoarder cleanout take?", a: "Light hoarding (Level 2) often takes 2–3 days. Severe situations (Level 4–5) can take 1–3 weeks, especially when we work phased to protect the homeowner." },
      { q: "Do you handle biohazards and pest issues?", a: "Yes. Our crews are equipped for animal waste, decomposing food, mold, sharps, and pest infestations. For active rodent or insect problems we coordinate with a local exterminator." },
    ]}
    ctaHeadline="There's a way through this. Let's start."
  />
);

export default HoarderCleanout;
